import React from 'react'
import Reset from '../Reset/Reset'

const ImagesDisplayTitle = (props) => {

    return (
        <div className="row">
            <div className="col-lg-12 text-center">
                <h2 className="section-heading">{props.display.title}</h2>
                <h3 className="section-subheading text-muted">{props.display.subtitle}</h3>
            </div>
        </div>
    )
}

const ImagesDisplayContent = (props) => {

    const modal = {
        title: props.title,
        subtitle: props.subtitle,
        image: props.full_image
    }

    return (
        <div className="col-md-4 col-sm-6 portfolio-item">
            <a className="portfolio-link" data-toggle="modal" target="_self" href="#portfolioModal"
                onClick={() => props.showModal(modal)} >
                <div className="portfolio-hover">
                    <div className="portfolio-hover-content">
                        <i className="fas fa-plus fa-3x"></i>
                    </div>
                </div>
                <img className="img-fluid" src={props.image} alt="" style={{minHeight: '100px'}}/>
            </a>
            <div className="portfolio-caption">
                <h4>{props.title}</h4>
                <p className="text-muted">{props.subtitle}</p>
            </div>
        </div>
    )
}

const ImagesDisplayIterator = (props) => {

    let images = []
    let def = props.def;

    for (let i = 1; i <= def.images; i++) {
        let image = def.base_path + i + "s.jpg"
        let full_image = def.base_path + "b" + i + ".jpg"
        images.push(<ImagesDisplayContent key={i} title={def.title} subtitle={def.subtitle} image={image} full_image={full_image} showModal={props.showModal} />)
    }

    return (
        <div className="row">
            {images}
        </div>
    )
}

const ImagesDisplay = (props) => {

    return (
        <section className="bg-light page-section" id={props.display.key}>
            <div className="container">
                <ImagesDisplayTitle {...props} />
                {props.display.images &&
                    <div className="row">
                        {props.display.images.map((e, v) => (
                            <ImagesDisplayContent key={v} index={v} {...e} showModal={props.showModal} />
                        ))}
                    </div>
                }
                {props.display.images_def &&
                    <ImagesDisplayIterator def={props.display.images_def} showModal={props.showModal} />
                }
                <Reset></Reset>
            </div>
        </section>
    )

}

export default ImagesDisplay;